export default "__VITE_ASSET__Bt1T$8Ih__"